import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const RouterMenuActions = () => {
    const { t } = useTranslation('routerDetails');

    return (
        <Button form="routerMenuItemForm" htmlType="submit" type="primary">
            {t('routerDetails:menuItems.updateButton')}
        </Button>
    );
};

export default RouterMenuActions;
